import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import api from '../../axios/axios'; // Import the api instance

const Return = () => {
  const [status, setStatus] = useState(null);
  const [customerEmail, setCustomerEmail] = useState('');
  const [loading, setLoading] = useState(true); // State for loading indicator

  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const sessionId = urlParams.get('session_id');

    api.get(`user/session-status?session_id=${sessionId}`) // Use the api instance for the GET request
      .then((res) => {
        setStatus(res.data.status); // Access data from the response
        setCustomerEmail(res.data.customer_email);
        setLoading(false); // Set loading to false after receiving the response
      })
      .catch((error) => {
        setLoading(false); // Set loading to false if there is an error
      });
  }, []);

  if (loading) {
    // Display loading spinner or message while waiting for the response
    return (
      <div className="flex items-center justify-center h-screen bg-gray-100">
      <div className="flex flex-col items-center space-y-4">
        {/* Spinner Animation */}
        <div className="w-16 h-16 border-4 border-blue-500 border-t-transparent border-solid rounded-full animate-spin"></div>
    
        {/* Loading Text with Pulse Animation */}
        <div className="text-xl font-semibold text-gray-700 animate-pulse">
          Loading... Please wait.
        </div>
      </div>
    </div>
    
    );
  }

  if (status === 'open') {
    return <Navigate to="/checkout" />;
  }

  if (status === 'complete') {
    return (
      <section id="success">
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white p-8 rounded-lg shadow-lg w-11/12 sm:w-2/3 md:w-1/2 lg:w-1/3">
            <h2 className="text-2xl font-semibold text-green-600 mb-4 text-center">
              🎉 Order Successful!
            </h2>
            <p className="text-gray-700 text-center">
              Thank you for your purchase! A confirmation email has been sent to:
            </p>
            <p className="text-indigo-600 text-center font-medium my-2">
              {customerEmail}
            </p>
            <p className="text-gray-700 text-center">
              If you have any questions, please email us at:{" "}
              <a
                href="mailto:orders@example.com"
                className="text-blue-600 hover:underline"
              >
                ryan@odidor.com
              </a>.
            </p>
            <div className="mt-6 text-center">
              <button
                className="px-6 py-2 bg-indigo-600 text-white rounded-lg shadow hover:bg-indigo-700 transition"
                onClick={() => window.location.href = "/order-history"} // Adjust redirect as needed
              >
                Return to Orders
              </button>
            </div>
          </div>
        </div>
      </section>
    );
  }

  return null;
}

export default Return;